<template>
    <button class="button" :class="[
			{ 'button--disabled': disabled },
			{ 'button--invisible': !visible },
		]">
        <span v-if="hasIconSlot" class="button__icon">
            <slot name="icon"></slot>
        </span>
        <span v-if="hasComponentSlot" class="button__icon">
            <component :is="$slots.component"></component>
        </span>
        <span v-else-if="icon" class="button__icon">
            <span :class="`icon-${icon}`"></span>
        </span>
        <span v-if="amount > 0" class="button__amount" :class="{ 'button__amount--active': amount > 0 }">{{ buttonAmount }}</span>
        <span v-if="text" class="button__text">{{ text }}</span>
        <span v-if="label" class="button__label">{{ label }}</span>
    </button>
</template>

<script>
export default {
	data: () => ({
		buttonAmount: null,
		buttonActive: false,
		buttonIcon: null,
	}),
	watch: {
		amount: function() {
			this.buttonAmount = this.amount
		},
		disabled: function() {
			this.buttonActive = this.disabled
		},
		'$slots.icon': function() {
			this.buttonIcon = this.$slots.icon
		},
	},
	props: {
		visible: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		icon: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: null,
		},
		text: {
			type: String,
			default: null,
		},
		amount: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		hasIconSlot() {
			return !!this.$slots.icon
		},
		hasComponentSlot() {
			return !!this.$slots.component
		},
	},
}
</script>
<style lang="scss">
@import '~guyn';
@import '~henris';
.button-group {
	display: flex;
	justify-content: flex-end;
	&--row,
	&--column {
		.button {
			border-radius: var(--button-radius-top-left, 0em)
				var(--button-radius-top-right, 0em)
				var(--button-radius-bottom-right, 0em)
				var(--button-radius-bottom-left, 0em);
		}
	}
	&--row {
		flex-direction: row;
		.button:first-child {
			--button-radius-top-left: var(--button-radius);
			--button-radius-bottom-left: var(--button-radius);
		}
		.button:last-child {
			--button-radius-top-right: var(--button-radius);
			--button-radius-bottom-right: var(--button-radius);
		}
		.button + .button {
			border-left: 1px solid var(--button-shadow);
		}
	}
	&--column {
		flex-direction: column;
		.button:first-child {
			--button-radius-top-left: var(--button-radius);
			--button-radius-top-right: var(--button-radius);
		}
		.button:last-child {
			--button-radius-bottom-left: var(--button-radius);
			--button-radius-bottom-right: var(--button-radius);
		}
		.button:not(:last-child) {
			--button-shadow-height: 0;
		}
		.button__label {
			display: none;
		}
	}
}
.button {
	--button-shadow-height: 0.15em;
	--button-padding: calc(0.75vw + 0.75em);
	--button-radius: calc(0.25vw + 0.25em);

	--button-shadow: #{$guyn-Orange};

	border-radius: var(--button-radius-top-left, var(--button-radius))
		var(--button-radius-top-right, var(--button-radius))
		var(--button-radius-bottom-right, var(--button-radius))
		var(--button-radius-bottom-left, var(--button-radius));

	padding: var(--button-padding);
	padding-bottom: calc(var(--button-padding) - var(--button-shadow-height));
	border: none;
	position: relative;
	font-size: 1.5em;
	line-height: 1em;
	font-family: inherit;

	background-color: var(--button-background, #{$guyn-YellowLight});
	box-shadow: 0 var(--button-shadow-height) 0 0 var(--button-shadow);

	@media screen and (max-width: 750px) {
		font-size: 1em;
	}

	&:focus {
		outline: none;
	}
	&__label {
		position: absolute;
		top: 100%;
		left: 50%;
		color: white;
		padding: 0.5em;
		text-transform: uppercase;
		font-size: 0.5em;
		letter-spacing: 0.1em;
		transform: translateX(-50%);
	}
	&__amount {
		position: absolute;
		left: 100%;
		bottom: 100%;
		border-radius: 50%;

		min-width: 2em;
		height: 2em;
		line-height: 2em;
		background-color: var(--button-amount-background, #{$guyn-RedLight});
		box-shadow: 0 var(--button-shadow-height) 0 0
				var(--button-amount-shadow, #{$guyn-RedDark}),
			-0.15rem 0.25rem 2px 0 rgba(0, 0, 0, 0.25);
		font-size: calc(0.5vw + 0.5em);
		// transform: scale(var(--scale))
		// 	translate(var(--translateX, -50%), var(--translateY, 50%));
		transform: translate(-50%, 50%);
		z-index: 3;
		transition: all 0.3s ease-in-out;

		&--active {
			// animation: popAmount 0.3s ease-in-out forwards;
		}
	}
	&__text {
		color: $guyn-White;
		filter: drop-shadow(0px 1px 0px #{$guyn-BrownDark});
		text-shadow: 0 0 1rem $guyn-OrangeDark;
		transition: all 0.3s ease-in-out;
		transform: translate(var(--translateX, 0%), var(--translateY, 0%))
			scale(var(--scale));
	}
	&__icon {
		width: calc(2vw + 1em);
		height: calc(2vw + 1em);
		display: inline-block;
		--stroke: 0.15em;
		filter: drop-shadow(0px 1px 0px #{$guyn-BrownDark});
		text-shadow: 0 0 1rem $guyn-OrangeDark;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		filter: drop-shadow(0px 1px 0px #{$guyn-BrownDark})
			drop-shadow(0px 0px 0.5rem #{$guyn-OrangeDark});

		svg {
			width: calc(2vw + 2em);
			height: calc(2vw + 2em);
		}
	}

	//

	&--disabled {
		--button-background: #{$guyn-RedLight};
		--button-shadow: #{$guyn-RedDark};

		.button__icon {
			color: black;

			filter: blur(4px);
		}
	}
	&--invisible {
		display: none;
	}
	& + .button {
		// margin-left: 0.5em;
	}
}

.icon-menu {
	display: block;
	width: 2em;
	height: 2em;
	color: $guyn-NightblueDark;
	position: relative;
	span {
		@include menu(
			calc(1em + 1vw),
			calc(0.2em + 0.2vw),
			calc(0.2em + 0.2vw),
			white,
			calc(0.05em + 0.05vw)
		);
		// filter: drop-shadow(0px 2px 0px #{$guyn-BrownLight});
	}
	&--active span {
		@include menu-close();
	}
}
</style>
